import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'deliveryStatus',
    standalone: false
})
export class DeliveryStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
